import { t } from '@lingui/core/macro';
import { FilterButton } from '@pocketlaw/tetris';
import { SearchableMenu, SearchableMenuSingleSelectList } from 'shared/domains/common-ui/SearchableMenu';
import { useFilter } from '../useFilter';
export function SingleSelectOperator(props) {
    const { name, items } = props;
    const filter = useFilter(name);
    const selectedItem = items.find((item) => {
        var _a;
        const currentValue = (_a = filter.value) === null || _a === void 0 ? void 0 : _a[filter.operator];
        return currentValue === item.value;
    });
    const selectedTitle = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title) ||
        t({
            message: 'Select value',
            comment: 'Search filter: Single select placeholder',
        });
    const handleOnChange = (item) => {
        filter.applyValue({ [filter.operator]: item.value });
    };
    return (<SearchableMenu items={items} keys={['title']} placeholder={t({ message: 'Search', comment: 'Single select search input placeholder' })} renderTarget={<FilterButton appearance={filter.isTouched ? 'draft' : 'default'}>{selectedTitle}</FilterButton>}>
      <SearchableMenuSingleSelectList selected={selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id} renderItem={({ title }) => title} onSelect={handleOnChange}/>
    </SearchableMenu>);
}
